import { ref, getCurrentInstance } from "vue";
import { useFormStore } from "@/stores/form";
import { storeToRefs } from "pinia";

// Composable for handling form submissions
export function useFormSubmissionHandler() {
  const isSubmitted = ref(false);
  const formStore = useFormStore();
  const { pages, styling } = storeToRefs(formStore);
  const instance = getCurrentInstance();

  /**
   * Common submit handler logic
   * @param {Object} event - Submission event
   * @param {Boolean} isPreview - Whether this is a preview submission
   */
  const handleSubmit = (event, isPreview = false) => {

    // Mark as submitted
    isSubmitted.value = true;

    // Find thank you page
    const thankYou = pages.value.find((page) => page.type === "thank-you");

    if (thankYou) {
      // Handle thank you page display
      styling.value.multiPage = false;
      const formRef = instance?.refs?.formesterForm;
      if (formRef) {
        formRef.resetCurrentPage();
        formRef.formSubmitted(event?.thankYouPageId);
      }
    } else if (!isPreview) {
      // Handle redirection for non-preview forms
      try {
        // Use window.parent for iframe compatibility
        if (event?.redirection_url) {
          window.parent.location.href = event.redirection_url;
        } else {
          window.parent.location.pathname = "/thanks";
        }
      } catch (error) {
        // Handle iframe CORS errors gracefully
        const errorMessages = [
          "Failed to set the 'href' property on 'Location'",
          "Failed to set a named property 'href' on 'Location'",
          "The operation is insecure.",
        ];
        if (errorMessages.some((msg) => error.message.includes(msg))) {
          console.warn("Navigation failed:", error.message);
        } else {
          throw error;
        }
      }
    }
  };

  return {
    isSubmitted,
    handleSubmit,
  };
}
